(function ($) {

  Drupal.behaviors.hello = {
    attach: function (context, settings) {
      //console.log('hello world !');
    }
  };

  Drupal.behaviors.clickMeAll = {
    attach: function (context, settings) {
      var elements = $('.node.teaser');
      elements.css({'cursor':'pointer'})
              .on('click', function(){
                window.location = $(this).find('a').eq(0).attr('href');
              });
    }
  };

  Drupal.behaviors.smoothScroll = {
    attach: function (context, settings) {

      $('a[href^="#"]').click(function(){
      	var the_id = $(this).attr("href");
      	if (the_id === '#' || $(this).attr('role') == 'tab') {
      		return;
      	}
      	$('html, body').animate({
      		scrollTop:$(the_id).offset().top
      	}, 'slow');
      	return false;
      });

    }
  };

  Drupal.behaviors.hideBodyScrollbarWhenMenuIsDisplayed = {
    attach: function (context, settings) {
      $('#navigation')
        .on('show.bs.collapse', function () {
          $('body').addClass('menu-shown');
        })
        .on('hidden.bs.collapse', function () {
          $('body').removeClass('menu-shown');
        });
    }
  };

  Drupal.behaviors.paragraphImageSlider = {
    attach: function (context, settings) {
      $('.paragraph--type--images.slider .field_image').slick({
        infinite: true,
        speed: 300,
        adaptiveHeight: true
      });
    }
  };

  Drupal.behaviors.produitSlider = {
    attach: function (context, settings) {
      $('.node.produit .slider').slick({
        infinite: true,
        speed: 300,
        adaptiveHeight: true
      });
    }
  };

  Drupal.behaviors.miseEnAvantSlider = {
    attach: function (context, settings) {
      $('.mise-en-avant .slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.mise-en-avant .thumbs'
      });
      $('.mise-en-avant .thumbs').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.mise-en-avant .slides',
        dots: true,
        centerMode: true,
        focusOnSelect: true
      });
    }
  };

  Drupal.behaviors.diaporamaSlider = {
    attach: function (context, settings) {
      $('.paragraph--type--diaporama .slider-portrait').slick({
        infinite: true,
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        adaptiveHeight: true,
        asNavFor: '.paragraph--type--diaporama .slider-titre'
      });
      $('.paragraph--type--diaporama .slider-titre').slick({
        infinite: true,
        speed: 1000,
        adaptiveHeight: true,
        arrows: false,
        fade: true,
        swipe: false,
        touchMove: false
      });
      $('.paragraph--type--diaporama .slider-photo').slick({
        infinite: true,
        speed: 500,
        adaptiveHeight: true,
        arrows: false,
        fade: true,
        swipe: false,
        touchMove: false
      });

      $('.paragraph--type--diaporama .slider-portrait').on('afterChange',function(event, slick, currentSlide){
        //$('.paragraph--type--diaporama .slider-photo').show().delay(5000).slick('slickGoTo',currentSlide);
        setTimeout(function(elem,curSlide){elem.slick('slickGoTo',curSlide);},500,$('.paragraph--type--diaporama .slider-photo'),currentSlide);
      });

    }
  };

  Drupal.behaviors.mapSearchHack = {
    attach: function (context, settings) {
      $(document).ajaxStop(function() {
        //console.log('ajax stopped',$('.result.found').html(),$('.result.found').html().replace(/\s/g,'')=='');
        if($('.result.found').length>0 && $('.result.found').html().replace(/\s/g,'')!=''){
          $('.full-map').hide();
          //console.log('found');
        }else{
          $('.full-map').show();
          //console.log('not found');
        }
      });
    }
  };

  Drupal.behaviors.fixedHeader = {
    attach: function (context, settings) {
      var elem = $("#entete");

      $(window).scroll(function(){
        if($(this).scrollTop() > 100){
          elem.addClass('sticked');
        }else{
          elem.removeClass('sticked');
        }
      });
    }
  };

  Drupal.behaviors.submenuTouchedScreen = {
    attach: function (context, settings) {
      window.addEventListener('touchstart', function onFirstTouch() {

        $('.menu li.expanded > a').on('click', function(e){
          if(!$(this).parent('li').hasClass('open')){
            e.preventDefault();
            $(this).parents('.menu').find('li.expanded.open').removeClass('open');
            $(this).parent('li').addClass('open');
          }
        });

        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
      }, false);
    }
  };


  Drupal.behaviors.rgpd_infos = {
    attach: function (context, settings) {
      $('.rgpd_infos_collapse').collapse('hide');
      $('.rgpd_infos .toggler').click(function(){
        //$(this).hide();
        //$('#rgpd_infos_collapse').collapse('toggle');
        $(this).parent('.rgpd_infos').find('.rgpd_infos_collapse').collapse('toggle');
        $(this).parent('.rgpd_infos').toggleClass('open');
      });
    }
  };

  Drupal.behaviors.frontpagePresentation = {
    attach: function (context, settings) {
      equalizeHeights();

      window.onresize = equalizeHeights;
    }
  };
  function equalizeHeights(){
    var col1 = document.querySelector('.frontpage-presentation .col-lg-5');
    var col2 = document.querySelector('.frontpage-presentation .col-lg-7');
    var windowWidth = window.innerWidth;

    if(col2 !== null){
      //col2.style.height = 'auto';
      col2.style.lineHeight = '1';

      if(windowWidth > 767){
        if(col1.offsetHeight > col2.offsetHeight){
          //col2.style.height = col1.offsetHeight+'px';
          col2.style.lineHeight = col1.offsetHeight+'px';
        }
      }
    }

  }

  $('a[href^="#"]').on('click', function(event) {
      var target = $(this).attr('href');
      if( target.length ) {
          event.preventDefault();
          $('html').animate({
              scrollTop: (($(target).offset().top)-200)
          }, 1000);
      }
  });

}(jQuery));
